<template>
  <el-select v-bind="$attrs" v-on="$listeners" ref="select" @hook:mounted="cancalReadOnly" @visible-change="cancalReadOnly" filterable v-model="curValue" >
    <slot></slot>
  </el-select>
</template>
<script>
export default {
  props: {
    value: {
      default: "",
    },
  },
  data() {
    return {
      curValue: this.value,
    };
  },
  watch: {
    curValue(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
  },
};
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/filter-select/index.vue"
}
</vue-filename-injector>
